<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>

      <v-row class="pa-2" no-gutters>
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1" :ripple="true"> مشاهده QR </v-tab>

            <v-tab :ripple="true"> پیش نمایش </v-tab>
            <v-tab :ripple="true" :disabled="e6<=1" >تعرفه‌ها</v-tab>
          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 100px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <div class="d-flex flex-column justify-center align-center">
                <qr-maker :loading="loading" />
                <div class="rowinfo">
                  <v-btn class="btn-download" @click="showDialog = true">
                    <v-icon>mdi-progress-download</v-icon>
                    {{ $t("download_qr") }}                  </v-btn>
                  <help-info
                    :element-name="`${serviceName}-${componentName}-download`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="دانلود کیوآر"
                  />
                </div>
              </div>
            </v-tab-item>

            <v-tab-item>
              <gallery-mobile v-model="cardTexts" :qr-svg-data-url="qrSvgDataUrl"/>
            </v-tab-item>
            <v-tab-item v-if="!!info?.id && e6>1">
                <Tariffs :id_qr="info.id" :qrtype="'pdfGallery'" />
             </v-tab-item>

          </v-tabs-items>
        </v-col>

        <v-col cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>وارد کردن اطلاعات گالری pdf</p>
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="cardTexts.visitName"
                    :disabled="e6 > 1"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="نام گالری شما"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="نام گالری"
                  />
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <qr-address-field
                    id="qr-address"
                    ref="address-field"
                    v-model="dtUrl"
                    :disabled="e6 > 1"
                    :error-messages="errors['identifier']"
                    append-icon="mdi-web"
                    class="mt-0 pt-0 contentinfo"
                    dense
                    outlined
                    persistent-hint
                    @updateDest="domainId = $event"
                    :key="$t('qrAddressUpdate.hints.allowedChars')"
                    :hint="$t('qrAddressUpdate.hints.allowedChars')"

                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-dtUrl`"
                    label="آدرس کیوآر"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                  />
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <div class="col-md-12 mt-4">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr"
                />
              </div>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2">
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <div class="mb-4">
                    <!-- سوییچ و آیکون راهنما -->
                    <div class="d-flex align-center">
                      <v-switch
                        v-model="AutoSave"
                        color="primary"
                        class="mt-0 pt-0 shrink"
                        hide-details
                        label="ذخیره خودکار"
                      ></v-switch>

                      <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            x-small
                            class="mr-1"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop
                          >
                            <v-icon small color="grey darken-1">
                              mdi-help-circle-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>
                          تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                        </span>
                      </v-tooltip>
                    </div>

                    <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                    <div
                      v-if="$vuetify.breakpoint.xsOnly"
                      class="text-caption grey--text text--darken-1 mt-1 pr-1"
                      style="line-height: 1.4"
                    >
                      تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                    </div>
                  </div>

              <list-expansion
                v-model="cardTexts"
                :components="specialInfo"
                :data="cardTexts"
                :service-name="serviceName"
                :component-name="componentName"
                flat
                @save-required="AutoSave && qrUpdate(false)"
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="qrUpdate(true)"
                />
              </div>
            </v-stepper-content>
          </v-stepper>

          <div class="d-none">
            <qr-code-make
              ref="qrCanvas"
              v-model="qrDesign"
              :file.sync="qrSvgDataUrl"
              :link="fullLink"
              @save="qrDesign = $event"
            />
          </div>

          <custom-popup
            v-model="showDialog"
            :cons="cons"
            hide-confirm
            max-width="900"
            transition="dialog-bottom-transition"
          >
            <template v-slot:helpinfo>
              <help-info
                :element-name="`${serviceName}-${componentName}-data-show-download-d`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="دانلود کیوآر"
              />
            </template>
            <v-card class="pa-5">
              <download-file-with-api
                v-if="showDialog"
                :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
                :visit-name="cardTexts.visitName"
                @close="showDialog = false"
                :qr_id="info.qrId"
              />
            </v-card>
          </custom-popup>
        </v-col>
      </v-row>
    </template>
      <QrIntroModal 
        storageKey="pdfGalleryIntroSeen"
        title="کیوآر گالری pdf"
        :pro="false"
        icon="mdi-file-pdf-box"
        iconColor="red darken-2"
        :description="introText"
      />
  </help-info-wrapper>
</template>

<script>
import QrIntroModal from "../../QrIntroModal.vue";
import { getLanguageCookie } from "../../../../core/plugins/TitleRibbon/utils/languageCookie";
import QrMaker from "@/view/pages/qrland/components/qrMaker.vue";
import GalleryMobile from "@/view/pages/otherQrTypes/pdfGallery/components/galleryMobile.vue";
import QrAddressField from "@/view/content/fragments/qrAddressField.vue";
import ListExpansion from "@/view/content/fragments/listExpansion.vue";
import NextBtn from "@/view/content/fragments/nextBtn.vue";
import DownloadFileWithApi from "@/view/pages/qrland/downloadFileWithApi.vue";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import { Bus } from "@/main";
import Tariffs from "../../../components/Tariffs/Tariffs.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "pdfGallery",

  components: {
    QrCodeMake,
    DownloadFileWithApi,
    NextBtn,
    ListExpansion,
    QrAddressField,
    GalleryMobile,
    QrMaker,
    Tariffs,
    QrIntroModal,
    AtomSpinner
  },

  data() {
    return {
      isAutoSaving: false, 
      AutoSave:false,

      introText: `
        <strong>کیوآر گالری PDF</strong> یک راهکار هوشمند برای نمایش و اشتراک‌گذاری مجموعه‌ای از فایل‌های PDF در یک صفحه اختصاصی و زیباست. با این ابزار می‌توانید کاتالوگ‌ها، بروشورها، نمونه‌کارها یا هر سند دیگری را به سادگی در اختیار مخاطبان خود قرار دهید.
        <br><br>
        <strong>امکانات این صفحه:</strong>
        <br>
        <span style="padding-right: 15px; display: block;">
          <strong>۱. بارگذاری و مدیریت فایل‌ها:</strong> امکان آپلود چندین فایل PDF و مرتب‌سازی آن‌ها برای ساخت یک آرشیو یا گالری دیجیتال منظم.<br>
          <strong>۲. شخصی‌سازی اطلاعات هر سند:</strong> برای هر PDF می‌توانید یک عنوان، توضیحات و تصویر پیش‌نمایش مجزا تعریف کنید تا مخاطب قبل از دانلود، اطلاعات کاملی از آن داشته باشد.<br>
          <strong>۳. سفارشی‌سازی کامل صفحه:</strong> تنظیم عنوان اصلی و زیرعنوان گالری، آپلود لوگوی اختصاصی و انتخاب تم رنگی (شامل رنگ هدر، بدنه و متن‌ها) متناسب با برند شما.
        </span>
        <br>
        این کیوآر برای رستوران‌ها (نمایش منو)، شرکت‌ها (نمایش کاتالوگ محصولات) و متخصصان (ارائه پورتفولیو) ایده‌آل است.
      `,
      helpData: [],
      serviceName: "Qrland",
      componentName: "pdfGallery",
      e6: 1,
      qrShow: 1,
      domainId: null,
      info: null,
      createdDomain: null,
      createdId: null,
      dtUrl: null,
      shortId: null,
      showDialog: false,
      loading: false,
      errors: {},
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      cardTexts: {
        visitName: "گالری pdf",

        pallete: {
          headColor: "linear-gradient(to bottom,#F7548AFF, #1A3870)",
          bodyColor: "linear-gradient(to bottom, #FFFFFF, #F1DFFBC4)",
          textColor: "#200101",
          borderColor: "#e2e8f0",
        },
        extraFields: [
          {
            icon: "mdi-information-outline",
            name: "راهنمای استفاده",
            value:
              "برای مشاهده، یا دانلود هر یک از فایل‌های PDF، لطفاً روی دکمه آن‌ها کلیک کنید.",
          },
        ],
        pdf: [
          {
            name: "گالری پروپزال‌های کیوآرلند",
            images: [
              {
                title: "پروپزال معرفی محصول",
                link: "https://cdn.terminalads.com/%D9%BE%D8%B1%D9%88%D9%BE%D8%B2%D8%A7%D9%84%20%DA%A9%DB%8C%D9%88%D8%A2%D8%B1%DA%A9%D8%AF%20%D9%85%D8%B9%D8%B1%D9%81%DB%8C%20%D9%85%D8%AD%D8%B5%D9%88%D9%84.pdf",
                url: "media/productpro.webp",
                description:
                  "معرفی کامل سرویس‌های کیوآرلند، نحوه کار QR کدهای هوشمند، مزایا برای کسب‌وکارها و نمونه کاربردها برای افزایش تعامل مشتریان.",
                selected: true,
              },
              {
                title: "پروپزال کارت ویزیت الکترونیکی",
                link: "https://cdn.terminalads.com/%D9%BE%D8%B1%D9%88%D9%BE%D9%88%D8%B2%D8%A7%D9%84%20%DA%A9%D8%A7%D8%B1%D8%AA%20%D9%88%DB%8C%D8%B2%DB%8C%D8%AA%20%D8%A7%D9%84%DA%A9%D8%AA%D8%B1%D9%88%D9%86%DB%8C%DA%A9%DB%8C.pdf",
                url: "media/cardvisit.webp",
                description:
                  "معرفی کارت ویزیت دیجیتال کیوآرلند، امکانات اشتراک سریع اطلاعات تماس، لینک شبکه‌های اجتماعی و مدیریت حرفه‌ای ارتباط با مشتریان.",
                selected: true,
              },
            ],
          },
        ],
        photo: {
          profile: "https://cdn.terminalads.com/upload/64b11ae97aae0.webp",
          transition: "scale",
          hasWelcome: false,
          headBackground: "https://cdn.terminalads.com/upload/67af0711b00c2.webp",
          showWelcome: false,
          hasGif: false,
          hasGame: false,

          previewerQr: {
            previewer: {
              gif: "",
              game: {},
              transition: "scale",
            },
          },
        },
        organizationName: "ترمینال تبلیغات",
        subtitle: "در کمتر از چند دقیقه سازمان خودرا به مخاطب معرفی کنید!",
        website: "www.core.terminalads.com",
        baseInfo: {
          sectionColor: {
            backGround: "linear-gradient(to right, #ffffff, #F0F4F8)",
            text: "#1E293B",
          },
          slider: false,
          grid: false,
        },
        socialMedia: {},
        pdfSelector: {
          title: "لیست اسناد و فایل‌ها",
          description: "فایل مورد نظر خود را از لیست زیر انتخاب کنید:",
          sectionColor: {
            backGround: "#FFFFFF",
            text: "#333333",
          },
          slider: false,
          layout: "list",
        },
      },
      specialInfo: [
        {
          name: "baseInfo",
          value: "",
          title: "اطلاعات",
          icon: "account-outline",
        },
        {
          name: "imageUploader",
          value: "",
          title: "آپلود لوگو",
          icon: "image",
          model: "photo",
        },
        {
          name: "pdfSelector",
          value: "",
          title: "افزودن گالری پی دی اف ",
          icon: "file",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: "افزودن شبکه های اجتماعی",
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ",
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
        },
      ],
      qrSvgDataUrl: "",
    };
  },
  computed: {
    defaultProfileImage() {
      return "https://cdn.terminalads.com/upload/64b11ae97aae0.webp";
    },
    defaultWebsite() {
      return this.$coreqrApi || "https://qr.terminalads.com";
    },
    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
    imageUrl_1() {
      return this.$cdnUrl + "/upload/6485f5712528f.webp";
    },
    imageUrl_2() {
      return this.$cdnUrl + "/upload/6485f56fe93f6.webp";
    },
    imageUrl_3() {
      return this.$cdnUrl + "/upload/6485f57221bc9.webp";
    },
    imageUrl_4() {
      return this.$cdnUrl + "/upload/6486cda4341fc.webp";
    },
    imageUrl_5() {
      return this.$cdnUrl + "/upload/6486cac9e99e1.webp";
    },
    imageUrl_6() {
      return this.$cdnUrl + "/upload/6486cf4c71122.webp";
    },
    imageUrl_7() {
      return this.$cdnUrl + "/upload/6486d1cad1870.webp";
    },
    imageUrl_8() {
      return this.$cdnUrl + "/upload/6487037d8ea38.webp";
    },
    imageUrl_9() {
      return this.$cdnUrl + "/upload/648703f54b008.webp";
    },
  },

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
      }
    },
  },
  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;

    this.cardTexts.photo.profile =
      "https://cdn.terminalads.com/upload/64b11ae97aae0.webp";
    this.cardTexts.website = this.$coreqrApi;
    this.cardTexts.socialMedia = {
      address: [
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qrland.ir",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qr.terminalads.com",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          label: "اینستاگرام",
          text: "نام کاربری خود را وارد نمایید",
          pattern: "https://instagram.com/",
          prefix: "@",
          url: "terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          label: "واتساپ",
          text: "+989123456789",
          pattern: "wa.me/",
          prefix: "mdi-phone",
          url: "+982191017077",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };

    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });
  },

  methods: {
    markQr(final = false) {
      if (
        !this.dtUrl ||
        typeof this.$refs["address-field"].dtUrlRule(this.dtUrl) !== "boolean"
      ) {
        this.$toast.clear();
        this.$toast.error("آدرس وارد شده صحیح نمی‌باشد!");
        return;
      }

      this.loading = true;
      let obj = {
        type: "pdfGallery",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
        qr: JSON.stringify(this.qrDesign),
      };
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.loading = false;
          this.createdDomain = this.$refs["address-field"].destItems.find(
            (item) => item.id === this.domainId,
          ).name;
          this.createdId = data.data.identifier;
          this.info = data.data;
          this.$toast.success("گالری pdf شما با موفقیت ساخته شد.");
          this.qrShow = 0;
          if (this.e6 === 1) {
            this.e6 = 2;
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate();
                this.qrShow = 1;
              }, 2000);
            });
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response.status === 422)
            this.$modal.error("خطا", response.data.message);
          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(
              ([fieldKey, fieldMessages]) => {
                try {
                  translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                    const key = errorMap[msg];
                    return key ? this.$t(key) : msg;
                  });

                  const msg = fieldMessages[0];
                  const key = errorMap[msg];
                  this.$toast.error(key ? this.$t(key) : msg, {
                    timeout: 3000,
                  });
                } catch (e) {
                  console.log("Error in mapping translation: ", e);
                }
              },
            );

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

          let el = document.getElementById("qr-address");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // async setSettings() {
    //   const res = await this.$refs.qrManage.update();
    //   this.e6 = 3
    // },
    qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      data.append("type", "pdfGallery");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");
      data.append("qr_id", this.info.qrId);
      data.append("_method", "PUT");
      data.append("qr", JSON.stringify(this.qrDesign));
      data.append(
        "data",
        JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
      );

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then((res) => {
          if (final) {
            this.goto("qr/list");
            this.$toast.success("کیوآر گالری pdf شما باموفقیت ویرایش شد.");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.isAutoSaving = false;

        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;

        });
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
